import { create } from 'zustand';
import { rulesService, type RuleData } from '../services/rulesService';

interface RulesState {
  
  saveRule: (ruleData: RuleData) => Promise<any>;
  getListRules: (params?: { page?: number; page_size?: number; search?: string }) => Promise<any>;
}

export const useRulesStore = create<RulesState>(() => ({


  saveRule: async (ruleData: RuleData) => {
    
    try {
      const result = await rulesService.saveRule(ruleData);
      return result
    } catch (error) {
      console.error('Error saving Rule:', error);
      return false;
    }

  },
  getListRules: async (params?: { page?: number; page_size?: number; search?: string }) => {
    try {
      const response = await rulesService.getRulesList(params);
      return response;
    } catch (error) {
      console.error('Error fetching Rules:', error);
      throw error;
    }
  }
}));
